import { render, staticRenderFns } from "./CompaignAudienceDefination.vue?vue&type=template&id=f552ae00&scoped=true&"
import script from "./CompaignAudienceDefination.vue?vue&type=script&lang=js&"
export * from "./CompaignAudienceDefination.vue?vue&type=script&lang=js&"
import style0 from "./CompaignAudienceDefination.vue?vue&type=style&index=0&id=f552ae00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f552ae00",
  null
  
)

export default component.exports